
import { useEffect, useState } from 'react';

// Shared state across hook instances within the same tab
let subscribers = new Set();
let currentVersion = null;
let updateAvailable = false;
let intervalId = null;
let initialized = false;
let lastInterval = 120000;
let broadcastChannel = null;
const storageKey = 'version-check-reload';
const sourceId = Math.random().toString(36).slice(2);

// Reload the page with a cache-busting query param
// Reload the page with a cache-busting query param
const performReload = () => {
        // const url = new URL(window.location.href);
        // url.searchParams.set('v', Date.now().toString());
        // window.location.replace(url.toString());

        // Force hard refresh with cache clearing to update entire DOM
        // This ensures all resources are reloaded from server, not from cache
        window.location.reload(true);
};

// Fetch and compare version from meta.json
const fetchVersion = async () => {
        try {
                const response = await fetch('/meta.json', { cache: 'no-store' });
                const data = await response.json();
                const remoteVersion = data.version;

                if (!currentVersion) {
                        currentVersion = remoteVersion;
                        subscribers.forEach((cb) => cb({ version: currentVersion, updateAvailable }));
                        return;
                }

                if (currentVersion !== remoteVersion) {
                        updateAvailable = true;
                        subscribers.forEach((cb) => cb({ version: currentVersion, updateAvailable }));
                }
        } catch (error) {
                console.error('Version check failed', error);
        }
};

const startChecking = () => {
        if (intervalId || document.visibilityState !== 'visible') return;
        fetchVersion();
        intervalId = setInterval(fetchVersion, lastInterval);
};

const stopChecking = () => {
        if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
        }
};

const handleVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
                startChecking();
        } else {
                stopChecking();
        }
};

const init = (interval) => {
        if (initialized) return;
        initialized = true;
        lastInterval = interval;

        if (typeof BroadcastChannel !== 'undefined') {
                broadcastChannel = new BroadcastChannel('version-check');
                broadcastChannel.onmessage = (event) => {
                        if (event.data?.type === 'reload' && event.data?.source !== sourceId) {
                                performReload();
                        }
                };
        } else {
                window.addEventListener('storage', (e) => {
                        if (e.key === storageKey) {
                                performReload();
                        }
                });
        }

        document.addEventListener('visibilitychange', handleVisibilityChange);
        if (document.visibilityState === 'visible') {
                startChecking();
        }
};

function useVersionCheck(interval = 60000) {
        const [state, setState] = useState({ version: currentVersion, updateAvailable });

        useEffect(() => {
                if (process.env.NODE_ENV !== 'production') return;
                if (typeof window === 'undefined' || typeof document === 'undefined') return;

                init(interval);

                const subscriber = (data) => setState(data);
                subscribers.add(subscriber);
                subscriber({ version: currentVersion, updateAvailable });

                return () => {
                        subscribers.delete(subscriber);
                        if (subscribers.size === 0) {
                                stopChecking();
                        }
                };
        }, [interval]);

        const reloadPage = () => {
                if (broadcastChannel) {
                        broadcastChannel.postMessage({ type: 'reload', source: sourceId });
                } else {
                        try {
                                localStorage.setItem(storageKey, `${Date.now()}`);
                        } catch (_) {
                                // ignore
                        }
                }
                // allow the broadcast to reach other tabs before navigating away
                setTimeout(performReload, 0);
        };

        return { version: state.version, updateAvailable: state.updateAvailable, reloadPage };
}

export default useVersionCheck;













































// import { useEffect, useState } from 'react';

// // Shared state across hook instances within the same tab
// let subscribers = new Set();
// let currentVersion = null;
// let updateAvailable = false;
// let intervalId = null;
// let initialized = false;
// let lastInterval = 60000;
// let broadcastChannel = null;
// const storageKey = 'version-check-reload';
// const sourceId = Math.random().toString(36).slice(2);

// // Reload the page with a cache-busting query param
// const performReload = () => {
//         // const url = new URL(window.location.href);
//         // url.searchParams.set('v', Date.now().toString());
//         // window.location.replace(url.toString());

//         // Clear any cached data and reload without URL parameters
//         // This prevents the double API calls issue
//         if (window.location.search) {
//                 // Remove any existing query parameters
//                 const cleanUrl = window.location.origin + window.location.pathname;
//                 window.location.replace(cleanUrl);
//         } else {
//                 // If no query parameters, just reload
//                 window.location.reload();
//         }
// };

// // Notify other tabs to reload
// const notifyReload = () => {
//         if (broadcastChannel) {
//                 broadcastChannel.postMessage({ type: 'reload', source: sourceId });
//         } else {
//                 try {
//                         localStorage.setItem(storageKey, `${Date.now()}`);
//                 } catch (_) {
//                         // ignore
//                 }
//         }
// };

// // Fetch and compare version from meta.json
// const fetchVersion = async () => {
//         try {
//                 const response = await fetch('/meta.json', { cache: 'no-store' });
//                 const data = await response.json();
//                 const remoteVersion = data.version;

//                 if (!currentVersion) {
//                         currentVersion = remoteVersion;
//                         subscribers.forEach((cb) => cb({ version: currentVersion, updateAvailable }));
//                         return;
//                 }

//                 if (currentVersion !== remoteVersion) {
//                         updateAvailable = true;
//                         subscribers.forEach((cb) => cb({ version: currentVersion, updateAvailable }));
//                 }
//         } catch (error) {
//                 console.error('Version check failed', error);
//         }
// };

// const startChecking = () => {
//         if (intervalId || document.visibilityState !== 'visible') return;
//         fetchVersion();
//         intervalId = setInterval(fetchVersion, lastInterval);
// };

// const stopChecking = () => {
//         if (intervalId) {
//                 clearInterval(intervalId);
//                 intervalId = null;
//         }
// };

// const handleVisibilityChange = () => {
//         if (document.visibilityState === 'visible') {
//                 startChecking();
//         } else {
//                 stopChecking();
//         }
// };

// const init = (interval) => {
//         if (initialized) return;
//         initialized = true;
//         lastInterval = interval;

//         if (typeof BroadcastChannel !== 'undefined') {
//                 broadcastChannel = new BroadcastChannel('version-check');
//                 broadcastChannel.onmessage = (event) => {
//                         if (event.data?.type === 'reload' && event.data?.source !== sourceId) {
//                                 performReload();
//                         }
//                 };
//         } else {
//                 window.addEventListener('storage', (e) => {
//                         if (e.key === storageKey) {
//                                 performReload();
//                         }
//                 });
//         }

//         document.addEventListener('visibilitychange', handleVisibilityChange);
//         if (document.visibilityState === 'visible') {
//                 startChecking();
//         }
// };

// function useVersionCheck(interval = 60000) {
//         const [state, setState] = useState({ version: currentVersion, updateAvailable });

//         useEffect(() => {
//                 if (process.env.NODE_ENV !== 'production') return;
//                 if (typeof window === 'undefined' || typeof document === 'undefined') return;

//                 init(interval);

//                 const subscriber = (data) => setState(data);
//                 subscribers.add(subscriber);
//                 subscriber({ version: currentVersion, updateAvailable });

//                 return () => {
//                         subscribers.delete(subscriber);
//                         if (subscribers.size === 0) {
//                                 stopChecking();
//                         }
//                 };
//         }, [interval]);

//         const reloadPage = () => {
//                 notifyReload();
//                 performReload();
//         };

//         return { version: state.version, updateAvailable: state.updateAvailable, reloadPage };
// }

// export default useVersionCheck;























// import { useEffect, useRef, useState } from 'react';

// function useVersionCheck(interval = 60000) {

//         const [version, setVersion] = useState(null);
//         const [updateAvailable, setUpdateAvailable] = useState(false);
//         const currentVersion = useRef(null);

//         useEffect(() => {
//                 // ✅ Only run in production
//                 if (process.env.NODE_ENV !== 'production') return;

//                 let isMounted = true;

//                 const fetchVersion = async () => {
//                         try {
//                                 // return;
//                                 const response = await fetch('/meta.json', { cache: 'no-store' });
//                                 const data = await response.json();
//                                 const remoteVersion = data.version;

//                                 if (!currentVersion.current) {
//                                         currentVersion.current = remoteVersion;
//                                         if (isMounted) setVersion(remoteVersion);
//                                         return;
//                                 }

//                                 if (currentVersion.current !== remoteVersion && isMounted) {
//                                         setUpdateAvailable(true);
//                                 }
//                         } catch (error) {
//                                 console.error('Version check failed', error);
//                         }
//                 };

//                 fetchVersion();
//                 const intervalId = setInterval(fetchVersion, interval);

//                 return () => {
//                         clearInterval(intervalId);
//                         isMounted = false;
//                 };
//         }, []);

//         // const reloadPage = () => {
//         //         const url = new URL(window.location.href);
//         //         url.searchParams.set('v', Date.now());
//         //         window.location.replace(url.toString());
//         // };

//         // ... existing code ...

//         const reloadPage = () => {
//                 // Clear any cached data and reload without URL parameters
//                 // This prevents the double API calls issue
//                 if (window.location.search) {
//                         // Remove any existing query parameters
//                         const cleanUrl = window.location.origin + window.location.pathname;
//                         window.location.replace(cleanUrl);
//                 } else {
//                         // If no query parameters, just reload
//                         window.location.reload();
//                 }
//         };

//         // ... existing code ...

//         return { version, updateAvailable, reloadPage };
// }

// export default useVersionCheck;
